module.exports = Package["email"];